/**
 * "Data fantasma" para oportunidades/licitaciones bloqueadas: textos plausibles
 * que se renderizan difuminados (blur + select-none). El valor real NO viaja al
 * cliente (el backend redacta nomenclatura/descripción), así el blur no se puede
 * burlar inspeccionando el DOM — es puramente cosmético sobre texto falso.
 */
export const GHOST_NOMENCLATURES = [
  "LICITACIÓN PÚBLICA N° 0000-2026-XX-XX/CE",
  "ADJUDICACIÓN SIMPLIFICADA N° 000-2026-XX",
  "CONCURSO PÚBLICO N° 00-2026-XX/CE-1",
  "CONTRATACIÓN DIRECTA N° 000-2026-XX-XX",
];

export const GHOST_DESCRIPTIONS = [
  "Adquisición de bienes y servicios para la entidad correspondiente al ejercicio fiscal vigente.",
  "Contratación del servicio de mantenimiento y suministro según los términos de referencia.",
  "Ejecución de obra pública conforme al expediente técnico aprobado por la entidad contratante.",
];

/** Provincia · distrito de una licitación bloqueada (el departamento sí se ve). */
export const GHOST_LOCATIONS = [
  "PROVINCIA · DISTRITO",
  "PROVINC · XXDISTRITO",
  "PROVINCIAX · DISTRI",
];

/** Códigos cortos para la columna de nomenclatura del catálogo de ítems. */
export const GHOST_CODES = [
  "LP-XXX-00-2025-XXX-CS-0",
  "AS-XXX-00-2025-XXX-CE-1",
  "CP-XX-2025-XXX-CE-0",
  "CD-XXX-00-2025-XXX-XX",
];

/** Elige determinísticamente un texto fantasma según una semilla (id/índice). */
export function ghostPick(seed: number, arr: string[]): string {
  return arr[Math.abs(seed) % arr.length]!;
}
